export default "__VITE_ASSET__CutGaLIC__"